import { render, staticRenderFns } from "./dataformname.vue?vue&type=template&id=333c3f4e&scoped=true&"
import script from "./dataformname.vue?vue&type=script&lang=js&"
export * from "./dataformname.vue?vue&type=script&lang=js&"
import style0 from "./dataformname.vue?vue&type=style&index=0&id=333c3f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333c3f4e",
  null
  
)

export default component.exports